export var list = [
    'notRequired',
    'notSelected',
    'selected',
];
